var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.elementType,{tag:"div",staticClass:"c_drawer",class:_vm.isActive ? 'c_drawer--active' : ''},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }